import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../styles.module.css';

export interface SamplesStatsBarProps {
  totalCount: number | null;
  /** null while the QC summary is still loading or unavailable. */
  passedQc: number | null;
}

const PLACEHOLDER = '—';

const SamplesStatsBar: FC<SamplesStatsBarProps> = ({ passedQc, totalCount }) => {
  const { t } = useTranslation('studies');

  const countText = totalCount !== null ? t('sample_count', { count: totalCount }) : t('sample_count_loading');

  return (
    <Stack alignItems="center" className={styles.statsBar} justifyContent="space-between" orientation="horizontal">
      <Text as="span" className={styles.sampleCount}>
        {countText}
      </Text>

      <Stack alignItems="center" gap={2} orientation="horizontal">
        <Text as="span" className={styles.statText}>
          {t('stat_studies')} | —
        </Text>
        <span aria-hidden="true" className={styles.statDivider} />
        <Text as="span" className={styles.statText} data-testid="samples-stat-passed-qc">
          {t('stat_passed_qc')} | {passedQc !== null ? passedQc.toLocaleString() : PLACEHOLDER}
        </Text>
        <span aria-hidden="true" className={styles.statDivider} />
        <Text as="span" className={styles.statText}>
          {t('stat_sample_groups')} | —
        </Text>
      </Stack>
    </Stack>
  );
};

export default SamplesStatsBar;
